module.exports = __webpack_public_path__ + "static/media/fine_motor_icon9792c32f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/fine_motor_icon.svg
// module id = 1328
// module chunks = 0